"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETeam = exports.getPlatformName = exports.AppSchema = exports.WebviewIntegrationApproach = exports.IntegrationVersion = exports.PlugType = exports.EDirectType = exports.EPlatform = exports.AppStatus = exports.AppMode = void 0;
const mongoose_1 = require("mongoose");
// ─── Enums ────────────────────────────────────────────────────────────────────
var AppMode;
(function (AppMode) {
    AppMode["OFFERWALL"] = "offerwall";
    AppMode["WEBVIEW"] = "webview";
})(AppMode = exports.AppMode || (exports.AppMode = {}));
var AppStatus;
(function (AppStatus) {
    AppStatus["ARCHIVED"] = "ARCHIVED";
    AppStatus["IN_DEVELOPMENT"] = "IN_DEVELOPMENT";
    AppStatus["READY"] = "READY";
    AppStatus["DISABLED"] = "DISABLED";
})(AppStatus = exports.AppStatus || (exports.AppStatus = {}));
var EPlatform;
(function (EPlatform) {
    EPlatform["GENERAL"] = "@";
    EPlatform["HUAWEI"] = "hw";
    EPlatform["SAMSUNG"] = "sm";
    EPlatform["ruSTORE"] = "rs";
    EPlatform["XIAOMI"] = "xm";
    EPlatform["APKPURE"] = "ap";
    EPlatform["TELEGRAM"] = "tg";
    EPlatform["AMAZON"] = "am";
    EPlatform["TEST"] = "test";
})(EPlatform = exports.EPlatform || (exports.EPlatform = {}));
var EDirectType;
(function (EDirectType) {
    EDirectType["KEITARO_OFFER"] = "keitaroOffer";
    EDirectType["OFFER_DIRECT"] = "offerDirect";
})(EDirectType = exports.EDirectType || (exports.EDirectType = {}));
var PlugType;
(function (PlugType) {
    PlugType["PASTEBIN"] = "PASTEBIN";
    PlugType["GIST"] = "GIST";
    PlugType["OTHER"] = "OTHER";
})(PlugType = exports.PlugType || (exports.PlugType = {}));
var IntegrationVersion;
(function (IntegrationVersion) {
    IntegrationVersion["NONE"] = "MVVM";
    IntegrationVersion["POLICY"] = "POLICY";
    IntegrationVersion["OFFER_STUB"] = "OFFER_STUB";
    IntegrationVersion["WEB"] = "WEB";
    IntegrationVersion["WEB_DIRECT"] = "WEB_DIRECT";
    IntegrationVersion["BANNER"] = "BANNER";
    IntegrationVersion["PWA"] = "PWA";
    IntegrationVersion["OFFERWALL"] = "OFFERWALL";
})(IntegrationVersion = exports.IntegrationVersion || (exports.IntegrationVersion = {}));
var WebviewIntegrationApproach;
(function (WebviewIntegrationApproach) {
    WebviewIntegrationApproach["SPLIT"] = "split";
    WebviewIntegrationApproach["ENCRYPT"] = "encrypt";
    WebviewIntegrationApproach["POLICY"] = "policy";
})(WebviewIntegrationApproach = exports.WebviewIntegrationApproach || (exports.WebviewIntegrationApproach = {}));
// ─── Mongoose schema ──────────────────────────────────────────────────────────
exports.AppSchema = new mongoose_1.Schema({
    id: {
        type: Number,
        unique: true,
        required: true
    },
    enabled: {
        type: Boolean,
        required: true,
        default: false
    },
    status: {
        type: String,
        enum: Object.values(AppStatus),
        default: AppStatus.IN_DEVELOPMENT
    },
    appMode: {
        type: String,
        enum: Object.values(AppMode),
        default: AppMode.OFFERWALL
    },
    appType: {
        type: String,
        required: false
    },
    bundle: {
        type: String,
        unique: true,
        required: true
    },
    name: String,
    geos: [String],
    campaign: {
        campaignId: { type: Number, default: 0 },
        campaignName: { type: String, default: 'none' },
        campaignAlias: { type: String, default: 'none' },
        campaignToken: { type: String },
        domainId: { type: Number, default: 0 },
        domainName: { type: String, default: 'none' },
        trackingParams: { type: Object }
    },
    campaignNaming: { type: Object, required: false },
    appsflyerParams: { type: Object },
    adjustParams: { type: Object },
    offerwallParams: { type: Object },
    domainParams: {
        name: { type: String },
        clouflareZone: { type: String },
        ready: { type: Boolean, default: false }
    },
    policyPath: {
        type: String,
        default: 'none'
    },
    postbacks: [{
            campaign_id: { type: Number, required: true },
            id: { type: Number, required: true },
            method: { type: String, enum: ['GET', 'POST'], required: true },
            statuses: [{ type: String, required: true }],
            url: { type: String, required: true },
            notes: { type: String, required: false }
        }],
    webviewConfig: { type: Object },
    serverId: { type: String },
    serverIp: { type: String },
    helperSync: { type: Object },
    webviewProvisioning: { type: Object },
    webviewRuntime: { type: Object }
});
// PDL may host multiple offerwall apps on one domain. The route, rather than
// the domain alone, is the unique runtime address; an empty path represents
// the single root-hosted offerwall for that domain.
exports.AppSchema.index({ 'domainParams.name': 1, 'offerwallParams.path': 1 }, {
    unique: true,
    name: 'domainParams.name_1_offerwallParams.path_1',
    partialFilterExpression: {
        appMode: AppMode.OFFERWALL,
        'domainParams.name': { $type: 'string' },
        'offerwallParams.path': { $type: 'string' }
    }
});
// ─── Helpers ──────────────────────────────────────────────────────────────────
const getPlatformName = (platform) => {
    switch (platform) {
        case EPlatform.SAMSUNG: return "samsung";
        case EPlatform.HUAWEI: return "huawei";
        case EPlatform.ruSTORE: return "ruStore";
        case EPlatform.XIAOMI: return "xiaomi";
        case EPlatform.APKPURE: return "apkpure";
        case EPlatform.TELEGRAM: return "telegram";
        case EPlatform.AMAZON: return "amazon";
        default: return false;
    }
};
exports.getPlatformName = getPlatformName;
/** @deprecated stub — ETeam was referenced in some legacy export */
var ETeam;
(function (ETeam) {
    ETeam["MAIN"] = "main";
})(ETeam = exports.ETeam || (exports.ETeam = {}));
